"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDetailsDialog = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const icons_material_1 = require("@mui/icons-material");
const material_1 = require("@mui/material");
const product_details_attributes_component_1 = require("./product-details-attributes/product-details-attributes.component");
const product_details_dialog_constants_1 = require("./product-details-dialog.constants");
const product_details_dialog_styles_1 = require("./product-details-dialog.styles");
const product_details_dialog_utils_1 = require("./product-details-dialog.utils");
const product_details_info_component_1 = require("./product-details-info/product-details-info.component");
const product_1 = require("../../client/product");
const product_tile_image_component_1 = require("../../components/product-tile/partials/product-tile-image.component");
const attributes_1 = require("../../constants/attributes");
const feature_flags_1 = require("../../../feature-flags");
const hooks_1 = require("../../../hooks");
const localization_1 = require("../../../localization");
const store_1 = require("../../../store");
const ProductDetailsDialog = ({ selectedProductId, productTreeNodeId, onClose, onNext, onPrevious, onReclassify, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { featureFlagsService } = (0, hooks_1.useFeatureFlagsService)();
    const isMeasureEnabled = featureFlagsService.isFeatureEnabled(feature_flags_1.FeatureFlag.Measures);
    const selectedCatalogId = (0, store_1.useSelectedCatalogId)();
    const { data, isLoading, error: _error, } = (0, product_1.useProductDetails)({
        catalogId: selectedCatalogId,
        productTreeNodeId,
        productId: selectedProductId,
        skipMeasures: !isMeasureEnabled,
        baseAttributes: product_details_dialog_constants_1.BASE_ATTRIBUTE_NAMES,
    });
    const _a = data !== null && data !== void 0 ? data : {}, { id, isLocked, validAttributions, measures, originalAttributions, baseAttributions } = _a, product = __rest(_a, ["id", "isLocked", "validAttributions", "measures", "originalAttributions", "baseAttributions"]);
    const productOriginalAttributions = (0, react_1.useMemo)(() => { var _a, _b; return (_b = (_a = originalAttributions === null || originalAttributions === void 0 ? void 0 : originalAttributions.edges) === null || _a === void 0 ? void 0 : _a.map(({ node }) => (Object.assign(Object.assign({}, node), { isValid: product_1.VALID_STATUSES.includes(node.status) })))) !== null && _b !== void 0 ? _b : []; }, [originalAttributions]);
    const productAttributions = (0, react_1.useMemo)(() => (0, product_details_dialog_utils_1.mergeTextAndMeasureProductAttributions)(validAttributions, measures), [validAttributions, measures]);
    const productBaseAttributions = (0, react_1.useMemo)(() => { var _a, _b; return (_b = (_a = baseAttributions === null || baseAttributions === void 0 ? void 0 : baseAttributions.edges) === null || _a === void 0 ? void 0 : _a.map(({ node }) => node)) !== null && _b !== void 0 ? _b : []; }, [baseAttributions]);
    const baseData = (0, react_1.useMemo)(() => (0, product_details_dialog_utils_1.getBaseDataFromProductAttributions)(product, productBaseAttributions), [productBaseAttributions, product]);
    const images = (0, react_1.useMemo)(() => {
        var _a;
        return (_a = productBaseAttributions
            .filter((item) => item.label === attributes_1.PRODUCT_IMAGE_LABEL)
            .map(({ value }) => String(value))) !== null && _a !== void 0 ? _a : [];
    }, [productBaseAttributions]);
    const imagesTiles = images.map((image) => (react_1.default.createElement(product_details_dialog_styles_1.StyledProductImageWrapper, { key: image }, react_1.default.createElement(product_tile_image_component_1.ProductTileImage, { image: image }))));
    return (react_1.default.createElement(product_details_dialog_styles_1.StyledDialog, { open: true, maxWidth: 'md', fullWidth: true, onClose: onClose, title: t({ key: 'EDIT_PRODUCT_DETAILS' }) }, react_1.default.createElement(product_details_dialog_styles_1.StyledDialogContentWrapper, null, react_1.default.createElement(product_details_dialog_styles_1.StyledProductDetailsWrapper, null, !!images.length && (react_1.default.createElement(ui_components_1.Carousel, { perView: 1, tiles: imagesTiles })), react_1.default.createElement(product_details_info_component_1.ProductDetailsInfo, { data: baseData, onReclassify: onReclassify })), react_1.default.createElement(product_details_dialog_styles_1.StyledProductDetailsAttributesWrapper, null, react_1.default.createElement(product_details_attributes_component_1.ProductDetailsAttributes, { productId: id, productTreeNodeId: productTreeNodeId, isLocked: Boolean(isLocked), productEnrichedAttributions: productAttributions, productOriginalAttributions: productOriginalAttributions }))), react_1.default.createElement(material_1.DialogActions, { className: 'switch-product-buttons' }, react_1.default.createElement(ui_components_1.Button, { disabled: isLoading, onClick: onPrevious, rounded: true }, react_1.default.createElement(icons_material_1.ChevronLeft, null), t({ key: 'PREVIOUS' })), react_1.default.createElement(ui_components_1.Button, { disabled: isLoading, onClick: onNext, rounded: true }, t({ key: 'NEXT' }), react_1.default.createElement(icons_material_1.ChevronRight, null)))));
};
exports.ProductDetailsDialog = ProductDetailsDialog;
